"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedResponseOfOrientationOpportunityDto = instanceOfPaginatedResponseOfOrientationOpportunityDto;
exports.PaginatedResponseOfOrientationOpportunityDtoFromJSON = PaginatedResponseOfOrientationOpportunityDtoFromJSON;
exports.PaginatedResponseOfOrientationOpportunityDtoFromJSONTyped = PaginatedResponseOfOrientationOpportunityDtoFromJSONTyped;
exports.PaginatedResponseOfOrientationOpportunityDtoToJSON = PaginatedResponseOfOrientationOpportunityDtoToJSON;
exports.PaginatedResponseOfOrientationOpportunityDtoToJSONTyped = PaginatedResponseOfOrientationOpportunityDtoToJSONTyped;
const OrientationOpportunityDto_1 = require("./OrientationOpportunityDto");
const PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta_1 = require("./PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta");
/**
 * Check if a given object implements the PaginatedResponseOfOrientationOpportunityDto interface.
 */
function instanceOfPaginatedResponseOfOrientationOpportunityDto(value) {
    if (!('result' in value) || value['result'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    return true;
}
function PaginatedResponseOfOrientationOpportunityDtoFromJSON(json) {
    return PaginatedResponseOfOrientationOpportunityDtoFromJSONTyped(json, false);
}
function PaginatedResponseOfOrientationOpportunityDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'result': (json['result'].map(OrientationOpportunityDto_1.OrientationOpportunityDtoFromJSON)),
        'meta': (0, PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta_1.PaginatedResponseOfFacilityOrientationListItemDtoAllOfMetaFromJSON)(json['meta']),
    };
}
function PaginatedResponseOfOrientationOpportunityDtoToJSON(json) {
    return PaginatedResponseOfOrientationOpportunityDtoToJSONTyped(json, false);
}
function PaginatedResponseOfOrientationOpportunityDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'result': (value['result'].map(OrientationOpportunityDto_1.OrientationOpportunityDtoToJSON)),
        'meta': (0, PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta_1.PaginatedResponseOfFacilityOrientationListItemDtoAllOfMetaToJSON)(value['meta']),
    };
}
//# sourceMappingURL=PaginatedResponseOfOrientationOpportunityDto.js.map